// The API reports sold-out as either a boolean or 0/1, under either casing.
export const isSoldOut = item =>
  item.sold_out === true || item.sold_out === 1 || item.soldOut === true || item.soldOut === 1

// The price a buyer is shown for a ticket or table, per fee mode:
// - forward_checkout: show cost (face value, fee added at checkout)
// - absorb: show x_face_value (organizer absorbs fee, customer pays face value only)
// - forward (default): show base_price (face value + fee)
export const getDisplayPrice = item => {
  if (item.fees_included === false) return parseFloat(item.cost || 0)
  if (!item.is_forward) return parseFloat(item.x_face_value || item.base_price || 0)
  return parseFloat(item.base_price || 0)
}
